import * as HttpService from './HttpService'

let namespace = 'containers'

let all = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

export {
    all
}



// WEBPACK FOOTER //
// ./src/services/containerService.js